import {call, put, takeLeading, select} from 'redux-saga/effects';
import {SET_SUBSCRIPTION_EMAIL, SET_SUBSCRIPTION_STATUS, SUBSCRIBE} from '../actions/subscribe';
import config from '../config';
import {getAnalyticsReferrerPolicy} from '../cookieConsent';


function* createEmailSubscriptionSaga() {
    const state = yield select(state => state.subscribe);
    const email = state.subscriptionEmail.trim();
    if (!email) {
        yield put({type: SET_SUBSCRIPTION_STATUS, payload: 'error'});
        return;
    }

    try {
        const response = yield call(fetch, `${config.apiHost}/map/api/newsletter-subscriptions`, {
            method: 'POST',
            referrerPolicy: getAnalyticsReferrerPolicy(),
            body: JSON.stringify({
                email
            }),
            headers: {
                'Content-Type': 'application/json'
            }
        });
        if (!response.ok) throw new Error('Subscription API error');
        yield put({type: SET_SUBSCRIPTION_EMAIL, payload: ''});
        yield put({type: SET_SUBSCRIPTION_STATUS, payload: 'success'});
    } catch (e) {
        yield put({type: SET_SUBSCRIPTION_STATUS, payload: 'error'});
    }

}

export function* watchSubscribe() {
    yield takeLeading(SUBSCRIBE, createEmailSubscriptionSaga);
}
